import { ILeaf, INode } from 'shared/types/tree'
import {
  allLeavesOfType,
  getQuestionType,
  nodesOfTypeWithContent,
} from '../../utility/TreeHelpers'
import { LeafTypes, NodeType, QuestionType } from 'shared/types/ingestion'

// Drawing question with images linked to staging environment will not render
export function stagingData(tree: INode) {
  const asString = JSON.stringify(tree)
  const total = (asString.match(/kiddom-media-staging/g) ?? []).length
  const extraCheck = (n: INode) => getQuestionType(n) === QuestionType.Drawing
  const nodes = nodesOfTypeWithContent({
    tree,
    extraCheck,
    types: [NodeType.Question],
    content: ['kiddom-media-staging'],
  })
  const nodeIds = nodes.map(({ id }) => id)
  return { total, questionNodesWithStagingImages: nodeIds }
}

export type UrlData = {
  nodes: INode[]
  leaves: ILeaf[]
  altText?: string | null
  url: string
}

export type AltTextByUrl = Record<string, UrlData>

export function isValidAltText({
  altText,
  url,
}: {
  altText: string | null
  url: string
}) {
  if (!altText) return false
  if (altText.length < 20 && altText.split('.').length > 3) return false
  return !url.includes(altText)
}

function isNotImageFile({ url, name }: { url: string; name?: string }) {
  return (
    url.endsWith('pdf') ||
    name?.endsWith('pdf') ||
    url.endsWith('txt') ||
    name?.endsWith('txt')
  )
}

export function leafAltTextData(tree: INode) {
  return allLeavesOfType(tree, LeafTypes.Attachment).reduce<AltTextByUrl>(
    (acc, leaf) => {
      const { url, alt: existingAlt } = leaf.body.file
      if (!url) return acc
      if (isNotImageFile(leaf.body.file)) return acc
      const altText = isValidAltText({ altText: existingAlt, url })
        ? existingAlt
        : undefined
      if (url in acc) {
        acc[url].leaves.push(leaf)
      } else {
        acc[url] = {
          nodes: [],
          leaves: [leaf],
          url,
          altText,
        }
      }
      return acc
    },
    {},
  )
}
